<script setup lang="ts">
import { useCurrentPlant, usePlantListStore } from "~/stores/plant-state.ts";
import { useEquipmentLookupListStore } from "~/stores/lookup-lists.ts";
const plantListStore = usePlantListStore();

const authStore = useAuthStore();
await authStore.refresh();
await plantListStore.check();
const PlantData = useCurrentPlant();

if (authStore.isAuthed && PlantData.data?.plantId) {
  const equipmentLookupListStore = useEquipmentLookupListStore();
  equipmentLookupListStore.fetch();
}
</script>

<template><slot /></template>

<style scoped lang="postcss"></style>
